import { useEffect, useState } from "react";
import ServiceTwoIcon from "./ServiceTwoIcon";

const EMPTY_VALUE = {
  brand: "",
  cost: "",
  partNumber: "",
  warrantyMonths: "",
  description: "",
};
const onlyDigits = (value) =>
  String(value || "")
    .replace(/[۰-۹]/g, (digit) => "۰۱۲۳۴۵۶۷۸۹".indexOf(digit))
    .replace(/[٠-٩]/g, (digit) => "٠١٢٣٤٥٦٧٨٩".indexOf(digit))
    .replace(/\D/g, "");

export default function ServiceDetailsModal({
  category,
  initialValue,
  onSave,
  onRemove,
  onClose,
}) {
  const [draft, setDraft] = useState(() => ({
    ...EMPTY_VALUE,
    ...(initialValue || {}),
  }));
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose]);
  const update = (field, value) =>
    setDraft((current) => ({ ...current, [field]: value }));

  return (
    <div
      className="service-details-modal"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="service-details-title"
        className="service-details-modal__sheet"
      >
        <header>
          <div>
            <span>
              <ServiceTwoIcon name="service" />
            </span>
            <div>
              <small>جزئیات سرویس</small>
              <h2 id="service-details-title">{category.title}</h2>
            </div>
          </div>
          <button type="button" onClick={onClose} aria-label="بستن">
            <ServiceTwoIcon name="close" />
          </button>
        </header>
        <div className="service-details-modal__notice">
          <ServiceTwoIcon name="info" />
          <p>
            اطلاعات این بخش اختیاری است، اما ثبت کامل آن سابقه دقیق‌تری برای
            مشتری ایجاد می‌کند.
          </p>
        </div>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            onSave(draft);
          }}
        >
          <div className="service-details-modal__fields">
            <label>
              <span>برند یا مدل قطعه</span>
              <input
                value={draft.brand}
                onChange={(event) => update("brand", event.target.value)}
                placeholder="مثال: Bosch"
              />
            </label>
            <label>
              <span>هزینه (ریال)</span>
              <input
                inputMode="numeric"
                value={draft.cost}
                onChange={(event) =>
                  update("cost", onlyDigits(event.target.value))
                }
                placeholder="مثال: ۲٬۵۰۰٬۰۰۰"
              />
            </label>
            <label>
              <span>کد یا شماره قطعه</span>
              <input
                dir="ltr"
                value={draft.partNumber}
                onChange={(event) => update("partNumber", event.target.value)}
                placeholder="اختیاری"
              />
            </label>
            <label>
              <span>ضمانت (ماه)</span>
              <input
                inputMode="numeric"
                value={draft.warrantyMonths}
                onChange={(event) =>
                  update("warrantyMonths", onlyDigits(event.target.value))
                }
                placeholder="مثال: ۶"
              />
            </label>
            <label className="is-wide">
              <span>توضیحات تکمیلی</span>
              <textarea
                value={draft.description}
                onChange={(event) => update("description", event.target.value)}
                placeholder="شرح وضعیت قطعه، اقدامات انجام‌شده یا نکته‌ای برای مراجعه بعدی"
                rows="3"
              />
            </label>
          </div>
          <footer>
            <button
              type="button"
              className="service-details-modal__remove"
              onClick={onRemove}
            >
              <ServiceTwoIcon name="trash" />
              حذف انتخاب
            </button>
            <button type="submit" className="service-details-modal__save">
              <ServiceTwoIcon name="check" />
              ذخیره جزئیات
            </button>
          </footer>
        </form>
      </section>
    </div>
  );
}
